import React from 'react';
import { Wrench, Hammer, FileText, Layers, Dumbbell, Truck } from 'lucide-react';
export function KitContents() {
  const items = [{
    icon: Wrench,
    title: 'Manual de Soldadura desde Cero'
  }, {
    icon: Hammer,
    title: 'Carpintería + proyectos listos para construir'
  }, {
    icon: FileText,
    title: 'Pack de Herrería con planos profesionales'
  }, {
    icon: Layers,
    title: '+1500 planos de muebles de melamina'
  }, {
    icon: Dumbbell,
    title: 'Planos de máquinas de gym'
  }, {
    icon: Truck,
    title: 'Planos de trailers'
  }];
  return <section className="bg-white py-4 md:py-12 px-4" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4 md:mb-8" data-id="element-131">
          🔧 Contenido del Mega Pack (500+ recursos)
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6" data-id="element-132">
          {items.map((item, index) => <div key={index} className="flex gap-4 p-3 md:p-5 bg-gray-50 rounded-xl border border-gray-100 shadow-sm" data-id="element-133">
              <div className="flex-shrink-0" data-id="element-134">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center text-[#f97316] font-bold text-xl" data-id="element-135">
                  <item.icon className="w-6 h-6" data-id="element-136" />
                </div>
              </div>
              <div className="flex items-center" data-id="element-137">
                <h3 className="text-xl font-bold text-gray-900" data-id="element-138">
                  {item.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}